/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { OnInit } from '@angular/core';


@Component({
  selector: 'zsd-contactinfo',
  templateUrl: '../../view/contactinfo/contactinfo.component.html',
  styleUrls: ['../../view/contactinfo/contactinfo.component.scss']
})
export class ContactinfoComponent implements OnInit {
  @Input('parentForm') public parentForm: FormGroup;
  showMeridiem = true;


  // contact type dropdown options

  contactTypePhone = 'Phone';
  contactTypePhoneIndex = 2;
  contactTypeEmail = 'Email';
  contactTypeEmailIndex = 1;
  contactTypeNone = 'None';
  contactTypeNoneIndex = 0;

  contactTypeOptions = ['none', 'email', 'phone'];

  // contact time dropdown options
  contactTimeOptions = ['12-2', '2-4', '4-6', '6-8', '8-10', '10-12'];

  // contact time tt dropdown options
  contactTimePeriodOptions = ['AM', 'PM'];
  contactTimeAm = 'AM';
  contactTimePm = 'PM';

  isPhone = true;
  isContactTypeNone = true;

  // email validation
  emailFocus: boolean;
  phoneFocus: boolean;

  contactInfoForm: FormGroup;

  constructor(public formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.contactInfoForm = this.formBuilder.group({
      email: this.formBuilder.control(''),
      phone: this.formBuilder.control(''),
      contactType: this.formBuilder.control(''),
      contactTime: this.formBuilder.control(''),
      contactTimeTt: this.formBuilder.control('')
    });
    this.contactInfoForm.get('contactType').setValue('0');
    this.contactInfoForm.get('contactTime').setValue('0');
    this.contactInfoForm.get('contactTimeTt').setValue('0');
    this.contactInfoForm.updateValueAndValidity();
    if (this.parentForm) {
      this.parentForm.addControl('contactInfo', this.contactInfoForm);
    }
  }

  changeContactType() {
    const selectedContactType = this.contactInfoForm.get('contactType').value;
    switch (selectedContactType) {
      case '0':
        this.isContactTypeNone = true;
        this.contactInfoForm.get('email').clearValidators();
        this.contactInfoForm.get('phone').clearValidators();
        this.contactInfoForm.updateValueAndValidity();
        this.parentForm.setControl('contactInfo', this.contactInfoForm);
        break;
      case '1':
        this.isContactTypeNone = false;
        this.isPhone = false;
        this.contactInfoForm.get('phone').clearValidators();
        this.contactInfoForm.get('email').setValidators([Validators.email, Validators.required]);
        this.contactInfoForm.updateValueAndValidity();
        this.parentForm.setControl('contactInfo', this.contactInfoForm);
        break;
      case '2':
        this.isContactTypeNone = false;
        this.isPhone = true;
        this.contactInfoForm.get('phone').setValidators([this.required]);
        this.contactInfoForm.get('email').clearValidators();
        this.contactInfoForm.updateValueAndValidity();
        this.parentForm.setControl('contactInfo', this.contactInfoForm);
    }
  }

  emailEmpty() {
    return this.contactInfoForm.get('email').value === '';
  }

  emailValidation() {
    // false if email is valid, true otherwise
    if (this.contactInfoForm.get('email').valid || this.contactInfoForm.get('email').value === '') {
      return false;
    } else {
      return true;
    }
  }

  public required(control: FormControl) {
    let isValid = !((control.value || '').trim().length === 0);
    return isValid ? null : { 'required': true };
 }


 public checkcontactTimeValue(value) {
 const selectedContactTime = this.contactInfoForm.get('contactTimeTt').value;
    if (value === '') {
      this.showMeridiem = false;
    } else {
      this.contactInfoForm.get('contactTimeTt').setValue(selectedContactTime);
      this.showMeridiem = true;
    }
    this.contactInfoForm.updateValueAndValidity();
}
}
